import type { PropsWithChildren } from 'react'
import * as React from 'react'

import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import config from 'constants/config'

interface Props {
  inverse?: boolean
  fallback?: React.ReactNode
}

function WishlistGuard(props: PropsWithChildren<Props>) {
  const { children, fallback = null, inverse } = props

  if (!!config.ENABLE_TRIP_PLANNER === !!inverse) {
    return <>{fallback}</>
  }

  return (
    // Keep wishlist controls on the default palette when embedded in offer cards.
    <ProductPaletteProvider palette="default">
      {children}
    </ProductPaletteProvider>
  )
}

export default WishlistGuard
